// extracted by mini-css-extract-plugin
export default {"main":"InfoBox_main__jkdKP"};